import { hasSensitiveConsent } from "@/lib/sensitiveConsent";
// Shared mapping between the profile and discovery search controls.
export function filtersFromProfile(profile, searchFilters = {}) {
  // Ignore legacy cached filters for the unavailable identity verification feature.
  const availableFilters = { ...searchFilters };
  delete availableFilters.verified_only;
  return {
    ...availableFilters,
    age_min: profile.age_min ?? 18,
    age_max: profile.age_max ?? 99,
    distance_km: profile.distance_km ?? null,
    interested_in: hasSensitiveConsent(profile, "relationships") ? (profile.interested_in_genders || []) : [],
    relationship_goals: profile.relationship_goals || [],
  };
}

export function preferencesFromFilters(filters) {
  return {
    age_min: filters.age_min ?? 18,
    age_max: filters.age_max ?? 99,
    distance_km: filters.distance_km ?? null,
    interested_in_genders: filters.interested_in || [],
    relationship_goals: filters.relationship_goals || [],
  };
}
